import React from 'react';
import './Footer.css';
import { useTranslation } from '../i18n';
import { APP_VERSION } from '../config/api.config';
import { sitePageUrl } from '../utils/siteLinks';

interface FooterProps {
  // Footer artık sadece iletişim ve telif hakkı bilgisi gösterir
}

const Footer: React.FC<FooterProps> = () => {
  const currentYear = new Date().getFullYear();
  const { t, language } = useTranslation();
  
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-bottom">
          <div className="copyright">
            <span>© {currentYear} Riselio. {t('footer.rightsReserved')}</span>
            <span className="footer-separator">•</span>
            <span className="version-info">{APP_VERSION}</span>
          </div>
          <div className="footer-links">
            <a className="footer-link" href={sitePageUrl('privacy', language)} target="_blank" rel="noopener noreferrer">
              {t('footer.privacy')}
            </a>
            <span className="footer-separator">•</span>
            <a className="footer-link" href={sitePageUrl('terms', language)} target="_blank" rel="noopener noreferrer">
              {t('footer.terms')}
            </a>
            <span className="footer-separator">•</span>
            <a className="footer-link" href={sitePageUrl('contact', language)} target="_blank" rel="noopener noreferrer">
              {t('footer.contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
